import React, { useState, useEffect, useCallback } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterItem,
  CharacterSpell,
  PseudoItem,
  SummonOption2,
} from "@dndModels";
import { ModelBase } from "@models";

// import DataUtilities from '../../../utilities/common_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import LoadingBox from "@components/input/LoadingBox";
import FilterBox from "@dndComponents/filtering/FilterBox";
import DandDAPI from "@dndUtilities/system_api";
import CharacterListOptionsRow from "@dndComponents/character/misc/CharacterListOptionsRow";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import LetterLinks from "@components/Navigation/LetterLinks";
import PageLinks from "@components/Navigation/PageLinks";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import { DataType, isDataType, isItemType, isProficiencyType, ItemType, ProficiencyType } from '@dndModels/Types';

interface Props {
  character: Character;
  data_type: DataType | ItemType | ProficiencyType | "char_spell" | "PseudoItem" | "special";
  filter?: any;
  // extra_filter?: (o: ModelBase | CharacterSpell | CharacterItem) => boolean;
  use_objects?: ModelBase[] | CharacterSpell[] | CharacterItem[] | SummonOption2[] | PseudoItem[];
  choose_max?: number;
  selected: string[];
  id_field?: string;
  selected_elsewhere?: string[];
  change_time?: number;
  quick_fields?: string[];
  force_selectable?: boolean;
  filter_on_change?: boolean;
  onChange?: (changed: string[]) => void;
  getDisabledReasons?: (obj: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  getName?: (obj: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  getDetails?: (obj: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  getSmallDetails?: (obj: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  extra_options?: (obj: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => React.ReactChild;
  sort?: (obj1: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem, obj2: ModelBase | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => number;
  onLoadedFilter?: (objects: ModelBase[]) => any;
}

const api = DandDAPI.getInstance();
// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterListOptionsInput({
  character,
  data_type,
  filter: true_filter,
  // extra_filter,
  use_objects,
  choose_max,
  selected,
  id_field = "_id",
  selected_elsewhere = [],
  change_time = 0,
  quick_fields,
  filter_on_change = false,
  onChange,
  getDisabledReasons,
  getName,
  getDetails,
  getSmallDetails,
  force_selectable = false,
  extra_options,
  sort,
  onLoadedFilter
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show_disabled, setShowDisabled] = useState(false);
  const [on_list, setOnList] = useState(false);
  const [reloading_filter, setReloadingFilter] = useState(false);
  const [ping, setPing] = useState(false);
  const [filtering, setFiltering] = useState(false);
  // const [true_filter, setTrueFilter] = useState<any>({ });
  const [objects, setObjects] = useState<ModelBase[] | CharacterSpell[] | CharacterItem[] | SummonOption2[] | PseudoItem[]>([]);
  const [filtered, setFiltered] = useState<ModelBase[] | CharacterSpell[] | CharacterItem[] | SummonOption2[] | PseudoItem[]>([]);
  const [disabled_length, setDisabledLength] = useState(0);
  const [page_num, setPageNum] = useState(0);
  const [prev_startLetter, setPrevStartLetter] = useState("");
  const [startLetter, setStartLetter] = useState("");
  const [filter, setFilter] = useState<any>({ search_string: [""] });
  const [prev_change_time, setChangeTime] = useState(0);

  const load = useCallback(async () => {
    // console.log(use_objects);
    // debugger;
    if (use_objects && use_objects.length > 0) {
      // debugger;
      if (onLoadedFilter && use_objects.length > 0 && use_objects[0] instanceof ModelBase) {
        const new_filter = onLoadedFilter(use_objects as ModelBase[]);
        setFilter(new_filter);
        setReloadingFilter(true);
      }
      setObjects(use_objects);
      setFiltering(true);
    } else if (isDataType(data_type)) {
      setLoading(true);
      let new_objects = await data_util.getGoodDataOfTypeAsync(data_type);
      // console.log(new_objects);
      if (true_filter) {
        new_objects = api.filter(data_type, new_objects, true_filter);
      }
      // debugger;
      if (onLoadedFilter) {
        const new_filter = onLoadedFilter(new_objects);
        setFilter(new_filter);
        setReloadingFilter(true);
      }
      setObjects(new_objects);
      setFiltering(true);
      setLoading(false);
    } else if (isProficiencyType(data_type)) {
      console.log(`Proficiency Type: ${data_type}`);
    } else if (isItemType(data_type)) {
      console.log(`Item Type: ${data_type}`);
    } else {
      console.log(data_type);
    }
  }, [use_objects, data_type]);
  
  useEffect(() => {
    if (!fetched) {
      // console.log("fetched");
      setFetched(true);
      load();
    }
  }, [fetched, load]);

  useEffect(() => {
    if (startLetter !== prev_startLetter) {
      // console.log("startLetter");
      updateFilter(filter);
      setPrevStartLetter(startLetter);
    }
    // eslint-disable-next-line
  }, [startLetter, prev_startLetter, setPrevStartLetter]);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      // console.log("change_time");
      setChangeTime(change_time);
      if (filter_on_change) {
        load();
      }
    }
  }, [change_time, prev_change_time, setChangeTime, load, filter_on_change]);

  useEffect(() => {
    if (filtering) {
      // console.log("filtering");
      refilter();
      setFiltering(false);
    }
    // eslint-disable-next-line
  }, [filtering]);

  useEffect(() => {
    if (reloading_filter) {
      setReloadingFilter(false);
    }
  }, [reloading_filter, setReloadingFilter]);

  const refilter = () => {
    // console.log("refilter");
    updateFilter(filter);
  }

  const updateFilter = (changed: any) => {
    const the_filter = {...changed};
    if (the_filter.effect_type) {
      the_filter.effect_types = the_filter.effect_type;
      delete the_filter.effect_type;
    }
    if (the_filter.attack_type) {
      the_filter.attack_types = the_filter.attack_type;
      delete the_filter.attack_type;
    }
    // console.log(objects);
    // debugger;
    let new_filtered = api.filter(data_type, objects, the_filter);
    if (startLetter !== "") {
      new_filtered = new_filtered.filter(o => o.name.startsWith(startLetter));
    }
    if (on_list) {
      new_filtered = new_filtered.filter(o => selected.includes((o as any)[id_field]));
    }
    the_filter.vehicle = { "$in": [undefined, false] };
    if (the_filter.proficient !== undefined) {
      if (new_filtered.length > 0 && new_filtered[0] instanceof PseudoItem) {
        const proficient = the_filter.proficient;
        new_filtered = (new_filtered as PseudoItem[]).filter(o => proficient === char_util.proficient(character, o));
      }
    }
    delete the_filter.proficient;
    // console.log(new_filtered);
    if (getDisabledReasons) {
      if (!show_disabled) {
        let new_disabled_length = new_filtered.length;
        new_filtered = new_filtered.filter(o => getDisabledReasons(o).length === 0);
        new_disabled_length -= new_filtered.length;
        setDisabledLength(new_disabled_length);
      } else {
        setDisabledLength(new_filtered.filter(o => getDisabledReasons(o).length > 0).length);
      }
    }
    new_filtered = new_filtered.sort((a, b) => {
      if (sort) {
        return sort(a,b);
      } else {
        return char_util.getUseName(a).localeCompare(char_util.getUseName(b));
      }
    });
    setFiltered(new_filtered);
    // setReloading(true);
  }

  // console.log(objects);
  if (!fetched || loading) {
    return (<LoadingBox />);
  } else { 
    // console.log(objects);
    // console.log(filtered);
    // console.log(selected);
    // console.log(selected_elsewhere);
    // console.log(filter);
    // console.log(choose_max);
    // console.log(force_selectable);
    if (choose_max && objects.length === choose_max && !force_selectable) {
      return (
        <Grid container spacing={0} direction="row">
          { objects.map(obj => {
            return (
              <Grid key={obj._id} container spacing={0} direction="row">
                <Grid
                  className="header centered"
                  size={{
                    xs: 12
                  }}>{ char_util.getUseName(obj) }</Grid>
                { getSmallDetails &&
                  <Grid
                    className="small_label gray"
                    size={{
                      xs: 12
                    }}>{ getSmallDetails(obj) }</Grid>
                }
                <Grid
                  style={{ border: "1px solid", padding: "4px", backgroundColor: "black" }}
                  size={{
                    xs: 12
                  }}>
                  <DisplayStringWithReplacements display_string={ getDetails ? getDetails(obj) : obj.description } cfs={character} />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      );
      // const obj = objects[0];
      // return (
      //   <Grid container spacing={0} direction="row">
      //     <Grid item xs={12} className="header centered">{ char_util.get_use_name(obj) }</Grid>
      //     <Grid item xs={12} style={{ border: "1px solid", padding: "4px", backgroundColor: "black" }}>
      //       <DisplayStringWithReplacements display_string={ getDetails ? getDetails(obj) : obj.description } cfs={character} />
      //     </Grid>
      //   </Grid>
      // );
    } else {
      // console.log(page_num);
      // console.log(filtered);
      const height = window.innerHeight - 221;
      const page_size = window.innerWidth >= 1000 ? Math.floor(height / 36.5) : 10;
      const page_count = Math.ceil(filtered.length / page_size);
      const filtered_and_paged = filtered.slice(page_size * page_num, page_size * (page_num + 1));
      // console.log(filtered);
      // if (reloading_filter) {
      //   debugger;
      // }
      return (
        <Grid container spacing={0} direction="row">
          { data_type === "summon" ?
            <>
            </>
          : 
            <Grid size={12}>
              { !reloading_filter && 
                <FilterBox 
                  data_type={data_type}
                  flat
                  dont_use_api
                  character_options={character.character_options}
                  the_filter={filter}
                  quick_fields={quick_fields}
                  // log_it
                  onChange={(changed: any) => {
                    setPageNum(0);
                    setStartLetter("");
                    setFilter(changed);
                    updateFilter(changed);
                  }}
                />
              }
            </Grid>
          }
          <Grid
            size={4}
            className="header centered">
            { choose_max === undefined ? 
              <></>
            : selected.length === 0 ? 
              <>
                Choose { choose_max }
              </>
            :
              <>
                {selected.length } of { choose_max } Chosen
              </> 
            } 
          </Grid>
          <Grid
            size={4}
            className="padded">
            { getDisabledReasons && disabled_length > 0 &&
              <ToggleButtonBox
                name="Show Disabled"
                value={show_disabled}
                onToggle={() => { 
                  setShowDisabled(!show_disabled); 
                  setFiltering(true);
                }}
              />
            }
          </Grid>
          <Grid
            size={4}
            className="padded">
            { selected.filter(o => o !== "").length > 0 &&
              <ToggleButtonBox
                name="Selected Only"
                value={on_list}
                onToggle={() => { 
                  setPageNum(0);
                  setOnList(!on_list);
                  setFiltering(true); 
                }}
              />
            }
          </Grid>
          <Grid size={12}>
            <PageLinks selected={page_num} page_count={page_count} onChange={setPageNum} />
          </Grid>
          <Grid
            size={12}
            container
            spacing={0}
            direction="row">
            { filtered_and_paged.sort((a,b) => { 
              return a.name < b.name ? -1 : 1;
            }).map(obj => {
              // if (obj.name.includes("Agonizing")) {
              //   debugger;
              // }
              // console.log(obj);
              const selected_count = selected.filter(o => o === (obj as any)[id_field]).length;
              const is_selected_elsewhere = selected_elsewhere.includes((obj as any)[id_field]);
              const variant_selected = obj instanceof ModelBase || obj instanceof CharacterSpell || obj instanceof CharacterItem ? obj.variant_group.filter(o => (obj as any)[id_field] !== (o as any)[id_field] && selected.includes((o as any)[id_field])).length > 0 : false;
              const disabled_reasons = getDisabledReasons ? getDisabledReasons(obj) : "";
              return (
                <Grid
                  key={(obj as any)[id_field]}
                  className="padded"
                  size={{
                    xs: 12
                  }}>
                  <CharacterListOptionsRow
                    character={character}
                    obj={obj}
                    selected={selected_count > 0}
                    selected_count={selected_count}
                    selected_elsewhere={is_selected_elsewhere}
                    variant_selected={variant_selected}
                    disabled_reasons={disabled_reasons}
                    total_selected={selected.length}
                    max={choose_max}
                    one_mode={choose_max === 1}
                    // log_it={obj.name.includes("Dagger")}
                    onChange={(new_count: number) => {
                      if (onChange) {
                        if (new_count === 0) {
                          onChange(selected.filter(o => (obj as any)[id_field] !== o));
                        } else {
                          if (choose_max === 1) {
                            onChange([(obj as any)[id_field]]);
                          } else {
                            const new_selected = selected.filter(o => (obj as any)[id_field] !== o);
                            for (let i = 0; i < new_count; ++i) {
                              new_selected.push((obj as any)[id_field]);
                            }
                            onChange(new_selected);
                          }
                        }
                        setPing(!ping);
                      }
                    }}
                    hide_add={onChange === undefined}
                    getName={getName}
                    getDetails={getDetails}
                    getSmallDetails={getSmallDetails}
                    extra_options={extra_options}
                  />
                </Grid>
              );
            })}
          </Grid>
          <Grid size={12}>
            <PageLinks selected={page_num} page_count={page_count} onChange={setPageNum} />
          </Grid>
          <Grid size={12}>
            <LetterLinks 
              onChange={(changed: string) => {
                setPageNum(0);
                setStartLetter(changed);
                setFiltering(true);
              }} 
            />
          </Grid>
        </Grid>
      );
    }
  }
}
